import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { endpoint } from '../../api';
import DashboardLayoutHome from './DashboardLayoutHome';
import { useDispatch } from 'react-redux';
import { setActiveDashboard } from '../../redux/slices/user.slice';

const DashboardOne = ({ id }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [dashboard, setDashboard] = useState([]);
  const [layouts, setLayouts] = useState([]);

  useEffect(() => {
    document.title = 'ISE Switchgear 2.0 - Dashboard';
  }, []);

  const getDashboard = async () => {
    if (!isLoading) {
      setIsLoading(true);
      const response = await axios.get(endpoint.dashboard + '/' + id, { withCredentials: true });
      console.log(response.data);
      if (response.status === 200) {
        setDashboard(response.data.result);
        setLayouts(response.data.result.layouts);
        setIsLoading(false);
      } else {
        dispatch(setActiveDashboard(''));
      }
    }
  };

  useEffect(() => {
    getDashboard();
  }, [id]);

  return (
    <div className="az-content-body">
      <div className="row row-sm mg-b-15 mg-sm-b-20">
        {dashboard?.items?.length > 0 ? (
          <DashboardLayoutHome
            allData={dashboard.items}
            layouts={layouts}
            mode={'view'}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        ) : dashboard.iframe ? (
          <iframe
            title="Dashboard"
            id="frame"
            scrolling="y"
            onLoad={(e, err) => {
              e.target.width = '100%';
              e.target.height = window.screen.height;
            }}
            frameBorder="0"
            src={dashboard.iframe}
            style={{ maxHeight: 800, width: '100%' }}
          >
            Iframe does not supported
          </iframe>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default DashboardOne;
